module.exports = __webpack_public_path__ + "img/j4.69f5395c.png";